import React from 'react'

const Widget = () => {
  return (
    <div>Widget</div>
  )
}

export default Widget